import { useNavigate } from 'react-router-dom';
import './Home.css';


const Home = () => {
    const navigate = useNavigate();

    return (
        <div className="Home">
            <div className="navs">
                <button onClick={() => navigate("/mint")} className="mint-button">Mint EmeraldBeta</button>
                <button onClick={() => navigate("/reputation")} className="reputation-button">View Reputation</button>
            </div>
        </div>
    );
}

export default Home;